import moment from "moment";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card } from "reactstrap";

import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import { createPaymentSlab, paymentSlabStatusOptions } from "../helper";
import { CREATE_SLAB_FORM_FIELDS, getDropdowns } from "./constants";


const InvigiatorNewSlab = () => {
    const history = useHistory();
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState({ ...CREATE_SLAB_FORM_FIELDS });
    const [dropdowns, setDropdowns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const masterDropdowns = useSelector(
        (state) => state.globalData.masterDropdowns,
    );
const [buOptions, setBuOptions] = useState(masterDropdowns?.businessArea || [])
    
    const filterBuForState=(buOptions,state)=>{
        console.log(buOptions, 'buOptions--')
        const businessArea= (masterDropdowns?.businessArea||[]).filter(item=>item?.stateCode==state?.value) ;
        setBuOptions(businessArea)
    }

    const handleFormChange = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };


    const isFormValid =
        form.state &&
        form.country &&
        form.bu &&
        form.effectiveDate &&
        form.status;


    const init = async () => {
        try {
            setIsLoading(true);
            const res = await getDropdowns();
            setDropdowns(res);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        init();
    }, []);

    const handleSaveChanges = async () => {
        if (!isFormValid) return;
        setSaving(true);
        try {
            const payload = {
                state: form.state?.label,
                stateId: form.state?.value,
                businessUnitId: form.bu?.businessAreaId,
                businessUnit: form.bu?.label,
                country: form?.country?.label,
                countryId: form?.country?.value,
                effectiveDate: form?.effectiveDate,
                status: form.status?.value,
                slabType: "INVIGILATOR",
                businessUnitType: (dropdowns.buType?.find(item=>item?.value==form?.bu?.businessUnitTypeId?.[0]))?.label
            };

            const response = await createPaymentSlab(payload);
            if (response?.id) {
                // Redirect to ViewEditSlab with the new slab ID
                history.push(`/admin/invigilatorPayrateSlab/${response.id}`);
            }
        } catch (error) {
            console.error("Error creating slab:", error);
            alert("Error creating slab. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="p-4">
            <div className="d-flex align-items-center mb-3">
                <BackIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => history.goBack()}
                />
                <h3 className="heading-3 mb-0 ml-2">Create New Slab</h3>
            </div>

            <Card className="p-4 mb-4">
                <h3 className="mb-4 text-bold">Slab setup</h3>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "20px",
                        marginBottom: "20px",
                    }}
                >
                    {/* Effective Date */}
                    <div>
                        <CustomDatePickerV2
                            placeHolder="From"
                            value={form?.effectiveDate}
                            width={"18px"}
                            label="Effective date"
                            handler={(index, date, keyName) => {
                                handleFormChange("effectiveDate", moment(date).format("YYYY-MM-DD"));
                            }}
                        />
                    </div>

                    {/* State */}
                    <div className="d-flex flex-column">
                        <AAutoComplete
                            label="State"
                            placeholder="Select"
                            isMulti={false}
                            items={dropdowns?.state}
                            currentValue={form?.state}
                            handleChange={(value) => {
                                handleFormChange("state", value)
                                handleFormChange("bu", "")
                                filterBuForState(buOptions, value)
                            }}
                            height="45px"
                        />
                    </div>

                    {/* Business Unit */}
                    <div>
                        <AAutoComplete
                            label="Business Unit"
                            placeholder="Select"
                            isMulti={false}
                            items={buOptions}
                            isDisabled={!form?.state}
                            currentValue={form?.bu}
                            handleChange={(value) => handleFormChange("bu", value)}
                            height="45px"
                        />
                    </div>

                    <div>
                        <AAutoComplete
                            label="Country"
                            placeholder="Select"
                            isMulti={false}
                            items={dropdowns.country}
                            currentValue={form?.country}
                            handleChange={(value) => handleFormChange("country", value)}
                            height="45px"
                        />
                    </div>
{/* 
                    <div>
                        <AAutoComplete
                            label="Business Unit Type"
                            placeholder="Select"
                            isMulti={false}
                            items={dropdowns.buType}
                            currentValue={form?.buType}
                            handleChange={(value) => handleFormChange("buType", value)}
                            height="45px"
                        />
                    </div> */}

                    <div>
                        <AAutoComplete
                            label="Status"
                            placeholder="Select"
                            isMulti={false}
                            items={paymentSlabStatusOptions}
                            currentValue={form.status}
                            handleChange={(value) => handleFormChange("status", value)}
                            height="45px"
                        />
                    </div>
                </div>

                <div style={{ width: "200px" }}>
                    <AButton
                        variant="primary_filled"
                        onClick={handleSaveChanges}
                        disabled={!isFormValid || saving}
                        className="w-full m-auto"
                    >
                        {saving ? "Saving..." : "Save changes"}
                    </AButton>
                </div>
            </Card>
        </div>
    );
};


export default InvigiatorNewSlab